import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import guid from '@/shared/utils/guid';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { ITransformedAssetClass } from '../types';

interface TableSumFooterProps {
  tableData: ITransformedAssetClass[];
  columnWidth: number;
}

interface AllocationSummary {
  [year: number]: number;
}

const TableSumFooter = ({ tableData, columnWidth }: TableSumFooterProps) => {
  const dateAllocations: AllocationSummary = {};

  const addAllocation = (date: string, allocation: number) => {
    const year = new Date(date).getFullYear();

    if (!dateAllocations[year]) {
      dateAllocations[year] = 0;
    }
    dateAllocations[year] += allocation;
  };

  tableData.forEach((assetClass) => {
    assetClass.allocations.forEach((allocation) => {
      addAllocation(allocation.endingDate, allocation.allocation === '-' ? 0 : parseFloat(allocation.allocation));
    });
  });

  return (
    <TableSumWrap>
      <TableSumItem width={15}>TOTAL</TableSumItem>
      {Object.values(dateAllocations).map((value) => (
        <TableSumItem key={guid()} width={columnWidth}>
          <FormattingTooltip zIndex={1000}>{value}</FormattingTooltip>
        </TableSumItem>
      ))}
    </TableSumWrap>
  );
};

const TableSumWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 60px;
  background-color: ${themeVar('layer.2')};
  border-radius: 8px;
  padding: 0 24px;
`;

const TableSumItem = styled.div<{ width: number }>`
  display: flex;
  justify-content: flex-start;
  width: ${({ width }) => `${width}%`};
  color: ${themeVar('font.base')};
  font-family: Blinker, serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0;
`;

export default TableSumFooter;
